import { HTTP, authHeader } from './http-service';

class ApiKeyService {
  create() {
    return HTTP.post(`/schemeapikey`, null, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }

  list() {
    return HTTP.get(`/schemeapikey`, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }

  delete(tmapikey) {
    return HTTP.delete(`/schemeapikey/${tmapikey}`, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }
}

export default new ApiKeyService();
